const fetchUserInfo = state => state.userInfo;
const getNewMessagesCount = state => state.getNewMessagesCount;
const unansweredNetworkRequestCount = state => state.unansweredNetworkRequestCount;

export default {
  fetchUserInfo,
  getNewMessagesCount,
  unansweredNetworkRequestCount,
};
